<template>
    <div class="page-table tabStyle mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">Ürün Detay</div>
        <el-row class="margin-top-10">
            <el-table
                    :data="newUrun"
                    border
                    stripe
                    style="width: 100%;">
                <template slot-scope="scope">
                    <el-table-column
                            width="250">
                        <template slot-scope="scope">
                            <div v-if="scope.row.detay.length > 0" class="right-box box grow tabloFirstChild">
                                <el-button v-on:click="getMalzemeList(scope)" icon="el-icon-edit" type="warning" size="mini"></el-button>
                                <dl>
                                    <dd style="font-size: 12px">ÜRÜN KODU : <span
                                            style="font-size: 14px; font-weight: bold">{{scope.row.urunKodu}}</span>
                                    </dd>
                                </dl>
                                <dl>
                                    <dd style="font-size: 12px">ÜRÜN ADI : <span
                                            style="font-size: 14px; font-weight: bold">{{scope.row.urunAdi}}</span>
                                    </dd>
                                </dl>
                                <dl>
                                    <dd style="font-size: 12px">MALZEME : <span
                                            style="font-size: 14px; font-weight: bold">{{scope.row.malzemeAdi}}</span>
                                    </dd>
                                </dl>
                                <dl>
                                    <dd style="font-size: 12px">OEM PARÇA NUMARASI</dd>
                                    <dt style="font-size: 14px;color: #ec205f">
                                        {{scope.row.uparcaKodu}}
                                    </dt>
                                </dl>
                                <dl>
                                    <el-button type="primary"
                                               v-on:click="urunKatalog(scope.row)" size="mini"> Ürün Katalog
                                    </el-button>
                                </dl>
                                <dl>
                                    <el-button type="warning"
                                               v-on:click="seciliUrunKatalog()" size="mini"> Seçili Ürün Katalog
                                    </el-button>
                                </dl>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="auto">
                        <template slot-scope="scope">
                            <el-table
                                    border
                                    :data="scope.row.detay"
                                    v-if="scope.row.detay.length > 0"
                                    style="width: 100%">
                                <el-table-column
                                        sortable
                                        :filters="filtersMarka"
                                        :filter-method="filterMarka"
                                        filter-placement="bottom-end"
                                        v-for="(column) in columnName"
                                        :label="column"
                                        width="250">
                                    <template slot-scope="{row,$index}">
                                        <div v-if="column === 'Katalog'">
                                            <el-switch
                                                    v-model="row.Katalog"
                                                    @change="exportKatalog(row)"
                                                    active-value="1"
                                                    inactive-value="0">
                                            </el-switch>
                                        </div>
                                        <div v-else-if="column === 'Araç Markası'"
                                             v-on:dblclick="doubleClick(row,$index,'editableMarka')">
                                            <el-autocomplete
                                                    size="mini"
                                                    v-if="editableMarka[$index]"
                                                    style="position: relative; right: 10px; width: 100%"
                                                    ref="searchHasta"
                                                    class="inline-input"
                                                    :fetch-suggestions="querySearchOpsiyon"
                                                    :clearable="false"
                                                    v-model="aracMarka"
                                                    @select="handleSelect($event,'aracMarka',$index,row)"
                                                    placeholder="Marka Ara"
                                                    :trigger-on-focus="false">
                                                <template slot-scope="{item}">
                                                    {{ item.cevap }}
                                                </template>
                                            </el-autocomplete>
                                            <span v-if="editableMarka[$index]" style="position: relative">
                                    <el-button
                                            v-on:click="clearable(row,$index,'editableMarka')"
                                            class="dangerbtn"
                                            type="text" size="mini"
                                            icon="el-icon-circle-close"></el-button>
                                    <el-button
                                            v-on:click="kaydet('Araç Markası',row,'editableMarka','cbMarka')"
                                            class="successbtn"
                                            type="text" size="mini"
                                            icon="el-icon-circle-check"></el-button>
                                    </span>
                                            <span v-else>{{row["Araç Markası"].value}}</span>
                                        </div>
                                        <div v-else-if="column === 'Araç Modeli'"
                                             v-on:dblclick="doubleClick(row,$index,'editableModel')">
                                            <el-autocomplete
                                                    size="mini"
                                                    v-if="editableModel[$index]"
                                                    style="position: relative; right: 10px; width: 100%"
                                                    ref="searchHasta"
                                                    class="inline-input"
                                                    :fetch-suggestions="querySearchOpsiyon"
                                                    :clearable="false"
                                                    v-model="aracModel"
                                                    @select="handleSelect($event,'aracModel')"
                                                    placeholder="Model Ara"
                                                    :trigger-on-focus="false">
                                                <template slot-scope="{item}">
                                                    {{ item.cevap }}
                                                </template>
                                            </el-autocomplete>
                                            <span v-if="editableModel[$index]" style="position: relative">
                                    <el-button
                                            v-on:click="clearable(row,$index,'editableModel')"
                                            class="dangerbtn"
                                            type="text" size="mini"
                                            icon="el-icon-circle-close"></el-button>
                                    <el-button
                                            v-on:click="kaydet('Araç Modeli',row,'editableModel','cbModel')"
                                            class="successbtn"
                                            type="text" size="mini"
                                            icon="el-icon-circle-check"></el-button>
                                    </span>
                                            <span v-else>{{row["Araç Modeli"].value}}</span>
                                        </div>
                                        <div v-else-if="column === 'Motor Kodu'"
                                             v-on:dblclick="doubleClick(row,$index,'editableMotor')">
                                            <el-autocomplete
                                                    size="mini"
                                                    v-if="editableMotor[$index]"
                                                    style="position: relative; right: 10px; width: 100%"
                                                    ref="searchHasta"
                                                    class="inline-input"
                                                    :fetch-suggestions="querySearchOpsiyon"
                                                    :clearable="false"
                                                    v-model="motorKodu"
                                                    @select="handleSelect($event,'motorKodu')"
                                                    placeholder="Motor Kodu Ara"
                                                    :trigger-on-focus="false">
                                                <template slot-scope="{item}">
                                                    {{ item.cevap }}
                                                </template>
                                            </el-autocomplete>
                                            <span v-if="editableMotor[$index]" style="position: relative">
                                        <el-button
                                                v-on:click="clearable(row,$index,'editableMotor')"
                                                class="dangerbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-close"></el-button>
                                        <el-button
                                                v-on:click="kaydet('Motor Kodu',row,'editableMotor','cbMotor')"
                                                class="successbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-check"></el-button>
                                        </span>
                                            <span v-else>{{row["Motor Kodu"].value}}</span>
                                        </div>
                                        <div v-else-if="column === 'CCM'"
                                             v-on:dblclick="doubleClick(row,$index,'editableCCM')">
                                            <el-autocomplete
                                                    size="mini"
                                                    v-if="editableCCM[$index]"
                                                    style="position: relative; right: 10px; width: 100%"
                                                    ref="searchHasta"
                                                    class="inline-input"
                                                    :fetch-suggestions="querySearchOpsiyon"
                                                    :clearable="false"
                                                    v-model="ccm"
                                                    @select="handleSelect($event,'ccm')"
                                                    placeholder="CCM Ara"
                                                    :trigger-on-focus="false">
                                                <template slot-scope="{item}">
                                                    {{ item.cevap }}
                                                </template>
                                            </el-autocomplete>
                                            <span v-if="editableCCM[$index]" style="position: relative">
                                        <el-button
                                                v-on:click="clearable(row,$index,'editableCCM')"
                                                class="dangerbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-close"></el-button>
                                        <el-button
                                                v-on:click="kaydet('CCM',row,'editableCCM','cbCCM')"
                                                class="successbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-check"></el-button>
                                        </span>
                                            <span v-else>{{row["CCM"].value}}</span>
                                        </div>
                                        <div v-else-if="column === 'kW'"
                                             v-on:dblclick="doubleClick(row,$index,'editablekW')">
                                            <el-autocomplete
                                                    size="mini"
                                                    v-if="editablekW[$index]"
                                                    style="position: relative; right: 10px; width: 100%"
                                                    ref="searchHasta"
                                                    class="inline-input"
                                                    :fetch-suggestions="querySearchOpsiyon"
                                                    :clearable="false"
                                                    v-model="kW"
                                                    @select="handleSelect($event,'kW')"
                                                    placeholder="kW Ara"
                                                    :trigger-on-focus="false">
                                                <template slot-scope="{item}">
                                                    {{ item.cevap }}
                                                </template>
                                            </el-autocomplete>
                                            <span v-if="editablekW[$index]" style="position: relative">
                                        <el-button
                                                v-on:click="clearable(row,$index,'editablekW')"
                                                class="dangerbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-close"></el-button>
                                        <el-button
                                                v-on:click="kaydet('kW',row,'editablekW','cbkW')"
                                                class="successbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-check"></el-button>
                                        </span>
                                            <span v-else>{{row["kW"].value}}</span>
                                        </div>
                                        <div v-else-if="column === 'PS'"
                                             v-on:dblclick="doubleClick(row,$index,'editablePS')">
                                            <el-autocomplete
                                                    size="mini"
                                                    v-if="editablePS[$index]"
                                                    style="position: relative; right: 10px; width: 100%"
                                                    ref="searchHasta"
                                                    class="inline-input"
                                                    :fetch-suggestions="querySearchOpsiyon"
                                                    :clearable="false"
                                                    v-model="ps"
                                                    @select="handleSelect($event,'ps')"
                                                    placeholder="PS Ara"
                                                    :trigger-on-focus="false">
                                                <template slot-scope="{item}">
                                                    {{ item.cevap }}
                                                </template>
                                            </el-autocomplete>
                                            <span v-if="editablePS[$index]" style="position: relative">
                                        <el-button
                                                v-on:click="clearable(row,$index,'editablePS')"
                                                class="dangerbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-close"></el-button>
                                        <el-button
                                                v-on:click="kaydet('PS',row,'editablePS','cbPS')"
                                                class="successbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-check"></el-button>
                                        </span>
                                            <span v-else>{{row["PS"].value}}</span>
                                        </div>
                                        <div v-else-if="column === 'Kullanıldığı Yıl'"
                                             v-on:dblclick="doubleClick(row,$index,'editableKullanildigiYil')">
                                            <el-date-picker
                                                    :clearable="false"
                                                    v-if="editableKullanildigiYil[$index]"
                                                    size="small"
                                                    style="width: 88%"
                                                    v-model="kullanildigiYil"
                                                    type="monthrange"
                                                    range-separator=" - "
                                                    start-placeholder="Başlangıç"
                                                    end-placeholder="Bitiş"
                                                    value-format="MM/yyyy"
                                                    format="MM/yyyy">
                                            </el-date-picker>
                                            <span v-if="editableKullanildigiYil[$index]"
                                                  style="position: relative; right: -10px">
                                        <el-button
                                                v-on:click="clearable(row,$index,'editableKullanildigiYil')"
                                                class="dangerbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-close"></el-button>
                                        <el-button
                                                v-on:click="kaydet('Kullanıldığı Yıl',row,'editableKullanildigiYil')"
                                                class="successbtn"
                                                type="text" size="mini"
                                                icon="el-icon-circle-check"></el-button>
                                        </span>
                                            <span v-else>{{row["Kullanıldığı Yıl"].value}}</span>
                                        </div>
                                        <!--<div v-else>-->
                                        <!--{{ row[column].value}}-->
                                        <!--</div>-->
                                        <div v-else
                                             v-on:dblclick="doubleClick(row,$index,'edit',scope.row.detay,column)">
                                            <el-input
                                                    size="mini"
                                                    v-if="scope.row.detay[$index][column].type"
                                                    style="position: relative; right: 10px; width: 100%"
                                                    class="inline-input"
                                                    :clearable="false"
                                                    v-model="input">
                                                {{ row[column].value }}
                                            </el-input>
                                            <span v-if="scope.row.detay[$index][column].type"
                                                  style="position: relative">
                                                <el-button
                                                        v-on:click="clearable(row,$index,'edit',scope.row.detay,column)"
                                                        class="dangerbtn"
                                                        type="text" size="mini"
                                                        icon="el-icon-circle-close"></el-button>
                                                <el-button
                                                        v-on:click="kaydet(column,row,'edit','cbPS')"
                                                        class="successbtn"
                                                        type="text" size="mini"
                                                        icon="el-icon-circle-check"></el-button>
                                            </span>
                                            <span v-else>{{row[column].value}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </el-row>
        <el-dialog title="Ürün Temel Bilgi Güncelle" width="30%" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="Resim : " label-width="120px">
                    <el-upload
                            action=""
                            list-type="picture-card"
                            :limit="1"
                            :file-list="imageListMain"
                            :auto-upload="false"
                            accept=".jpg,.jpeg,.png"
                            :on-change="imageUpload"
                            :on-remove="imageRemove">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="Ürün Kodu : " label-width="120px">
                    <el-input size="mini" v-model="form.urunKodu" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Ürün Adı : " label-width="120px">
                    <el-input size="mini" v-model="form.urunAdi" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Malzeme : " label-width="120px">
                    <el-select size="mini" filterable style="width: 100%;" v-model="form.malzemeKodu" autocomplete="off">
                        <el-option v-for="item in malzemeListesi"
                                   :key="item.malzemeKodu"
                                   :label="item.malzeme"
                                   :value="item.malzemeKodu"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="OEM Parça No : " label-width="120px">
                    <el-input size="mini" v-model="form.uparcaKodu" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false" size="mini">Vazgeç</el-button>
    <el-button type="primary" @click="urunGuncelle" size="mini">Kaydet</el-button>
  </span>
        </el-dialog>
    </div>

</template>
<script>
    import urunService from '../../../WSProvider/UrunService'
    import controllerService from '../../../WSProvider/ControllerService'

    import notification from '../../../notification'
    import JQuery from 'jquery';
    import EventBus from '@/components/event-bus'

    var base64 = require('base64_js');
    let $ = JQuery;
    export default {
        name: 'UrunDetay',
        data() {
            return {
                imageListMain: [],
                updateData: [],
                updateUrunId: '',
                formKlon : {},
                form: {
                    urunKodu: '',
                    urunAdi: '',
                    resim: '',
                    uparcaId : '',
                    malzemeKodu: '',
                    uparcaKodu: '',
                },
                malzemeListesi: [],
                dialogFormVisible: false,


                columnName: [],
                checked: true,
                urundata: this.$store.state.urundata,
                newUrun: [],
                aracMarkaListesi: [],
                aracModelListesi: [],
                motorKoduListesi: [],
                ccmListesi: [],
                kwListesi: [],
                psListesi: [],
                scope: {},
                scope1: {},
                cevap: '',
                cevapKodu: '',
                cevapMarkaId: '',
                cevapMarka: '',
                cevapKoduMarka: '',
                // form: {
                aracMarka: '',
                aracModel: '',
                model: '',
                motorKodu: '',
                ccm: '',
                kW: '',
                ps: '',
                input: '',
                kullanildigiYil: '',
                multipleSelection: [],
                // },
                editableKullanildigiYil: [],
                editableCCM: [],
                editablePS: [],
                editablekW: [],
                editableMarka: [],
                editableModel: [],
                editableMotor: [],
                edit: [],
                detay: [],
                ekleme: false,

                cbMarka: [],
                cbModel: [],
                cbCCM: [],
                cbPS: [],
                cbkW: [],
                cbMotor: [],

                filtersMarka: [],
                filtersModel: [],
                filtersMotor: [],
                filtersCCM: [],
                filtersPS: [],
                filterskW: [],
            }

        },
        mounted() {
            this.getParcaTablo(this.urundata);
            let self = this;
            EventBus.$on('urunGunc', function (bool) {
                if (bool) {
                    self.newUrun = [];
                    self.getParcaTablo(self.urundata);
                }
            });
        },
        methods: {
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('urun', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.form.resim = imgname;
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageRemove() {
                $('.el-upload--picture-card').show();
            },
            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "urun-" + randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg"
                        } else {
                            imgname = "urun-" + randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    this.sumResimFonk(file, imgname);
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            getMalzemeList(scope) {
                this.updateUrunId = scope.row.urunId;
                if(scope.row.resim){
                    $('.el-upload--picture-card').hide();
                }
                urunService.malzemeListesi().then((response) => {
                    if (response.status === 200) {
                        this.malzemeListesi = response.data;
                        this.dialogFormVisible = true
                    }
                });
                this.form = {
                    urunKodu: scope.row.urunKodu,
                    urunAdi: scope.row.urunAdi,
                    resim: scope.row.resim,
                    uparcaId: scope.row.uparcaId,
                    malzemeKodu: scope.row.malzemeKodu,
                    uparcaKodu: scope.row.uparcaKodu,
                };
                this.formKlon = {
                    urunKodu: scope.row.urunKodu,
                    urunAdi: scope.row.urunAdi,
                    resim: scope.row.resim,
                    uparcaId: scope.row.uparcaId,
                    malzemeKodu: scope.row.malzemeKodu,
                    uparcaKodu: scope.row.uparcaKodu,
                };
                this.imageListMain = [];
                this.imageListMain.push({
                    name: scope.row.resim,
                    url: urunService.imageUrlOrta + scope.row.resim
                });

            },
            urunGuncelle(scope) {
                for (var key in this.formKlon) {
                    if (key !== 'uparcaKodu') {
                        if (this.formKlon[key] !== this.form[key]) {
                            if (this.form[key] || this.form[key] === '') {
                                var item = {
                                    type: key,
                                    value: this.form[key]
                                };
                                this.updateData.push(item);
                            }
                        }
                    }else if (key === 'uparcaKodu'){
                        if (this.formKlon[key] !== this.form[key]) {
                            if (this.form[key] || this.form[key] === '') {
                                var item = {
                                    type: key,
                                    uparcaId: this.form.uparcaId,
                                    value: this.form[key]
                                };
                                this.updateData.push(item);
                                console.log(this.updateData)
                            }
                        }
                    }
                }
                urunService.urunTumGuncelleme(this.updateUrunId,this.updateData).then((response) => {
                    if (response.status === 200) {
                        this.urundata = response.data;
                        this.$store.commit('changeUrunData', response.data);
                        EventBus.$emit("urunGunc", true);
                        this.dialogFormVisible = false;
                        notification.Status('success', this, 'Ürün Bilgileri Güncellendi');
                    }else {
                        notification.Status(response.status, this)
                    }
                });
            },
            urunKatalog(scope) {
                var userDataEstasMil = JSON.parse(base64.decode(localStorage.getItem("userDataEstasMil")));
                window.open('https://estas.hakanbt.com.tr/katalog/estas-mil-cikti/index.php?UK=' + this.urundata.urunKodu + '&KATALOG=0&TOKEN=' + userDataEstasMil["token"], "_blank");

            },
            seciliUrunKatalog() {
                urunService.katalogGuncelle(this.multipleSelection).then((response) => {
                    if (response.status === 200) {
                        var userDataEstasMil = JSON.parse(base64.decode(localStorage.getItem("userDataEstasMil")));
                        window.open('https://estas.hakanbt.com.tr/katalog/estas-mil-cikti/index.php?UK=' + this.urundata.urunKodu + '&KATALOG=1&TOKEN=' + userDataEstasMil["token"], "_blank");
                    }
                });
            },
            filterMarka(value, row) {
                return row["Araç Markası"].cevapKodu === value;
            },
            filterModel(value, row) {
                return row["Araç Modeli"].cevapKodu === value;
            },
            filterMotor(value, row) {
                return row["Motor Kodu"].cevapKodu === value;
            },
            filterCCM(value, row) {
                return row["CCM"].cevapKodu === value;
            },
            filterPS(value, row) {
                return row["PS"].cevapKodu === value;
            },
            filterkW(value, row) {
                return row["kW"].cevapKodu === value;
            },
            //dede
            getParcaTablo(urundata) {
                let self = this;
                var dizi = [];
                if (urundata.parca[0]) {
                    Object.entries(urundata.parca[0]).forEach(entry => {
                        const [key, value] = entry;
                        if (key !== 'updetayKodu' && key !== 'uparcaKodu' && key !== 'uparcaId') {
                            self.columnName.push(key);
                        }
                    });
                }
                urundata.parca.forEach(function (e, i) {
                    dizi.push(e);
                    if (i === 0) {
                        self.newUrun.push({
                            uparcaKodu: urundata.parca[i].uparcaKodu,
                            urunAdi: urundata.urunAdi,
                            urunKodu: urundata.urunKodu,
                            malzemeAdi: urundata.malzemeAdi,
                            malzemeKodu: urundata.malzemeKodu,
                            urunId: urundata.urunId,
                            uparcaId : urundata.parca[i].uparcaId,
                            resim: urundata.resim,
                            detay: dizi
                        });

                    } else if (urundata.parca[i + 1] !== undefined && urundata.parca[i].uparcaKodu !== urundata.parca[i + 1].uparcaKodu) {
                        dizi = [];
                        self.newUrun.push({
                            uparcaKodu: urundata.parca[i + 1].uparcaKodu,
                            urunAdi: urundata.urunAdi,
                            urunKodu: urundata.urunKodu,
                            malzemeAdi: urundata.malzemeAdi,
                            malzemeKodu: urundata.malzemeKodu,
                            urunId: urundata.urunId,
                            uparcaId : urundata.parca[i].uparcaId,
                            resim: urundata.resim,
                            detay: dizi
                        });
                    }
                    var obj = self.filtersMarka.find(data => data.text === e["Araç Markası"].value);
                    if (obj === undefined) {
                        self.filtersMarka.push({
                            value: e["Araç Markası"].cevapKodu,
                            text: e["Araç Markası"].value,
                        })
                    }
                    var obj1 = self.filtersModel.find(data => data.text === e["Araç Modeli"].value);
                    if (obj1 === undefined) {
                        self.filtersModel.push({
                            value: e["Araç Modeli"].cevapKodu,
                            text: e["Araç Modeli"].value,
                        })
                    }
                    var obj2 = self.filtersMotor.find(data => data.text === e["Motor Kodu"].value);
                    if (obj2 === undefined) {
                        self.filtersMotor.push({
                            value: e["Motor Kodu"].cevapKodu,
                            text: e["Motor Kodu"].value,
                        })
                    }
                    var obj3 = self.filtersCCM.find(data => data.text === e["CCM"].value);
                    if (obj3 === undefined) {
                        self.filtersCCM.push({
                            value: e["CCM"].cevapKodu,
                            text: e["CCM"].value,
                        })
                    }
                    var obj4 = self.filtersPS.find(data => data.text === e["PS"].value);
                    if (obj4 === undefined) {
                        self.filtersPS.push({
                            value: e["PS"].cevapKodu,
                            text: e["PS"].value,
                        })
                    }
                    var obj5 = self.filterskW.find(data => data.text === e["kW"].value);
                    if (obj5 === undefined) {
                        self.filterskW.push({
                            value: e["kW"].cevapKodu,
                            text: e["kW"].value,
                        })
                    }
                });
                dizi = [];

                // console.log(this.newUrun)

            },
            doubleClick(scope, row, editable, detay, column) {
                if (editable === 'editableModel') {
                    this.cevapMarkaId = scope["Araç Markası"].id
                    this.cevapMarka = scope["Araç Markası"].value
                    this.cevapKoduMarka = scope["Araç Markası"].cevapKodu
                }
                this.scope = scope
                this.editableKullanildigiYil = []
                this.editableCCM = []
                this.editablePS = []
                this.editablekW = []
                this.editableMarka = []
                this.editableModel = []
                this.editableMotor = []
                this[editable] = []
                this[editable][row] = true;
                if (editable === 'edit') {
                    this.detay = detay;
                    Object.entries(detay).forEach(entry => {
                        const [key, value] = entry;
                        Object.entries(value).forEach(entry => {
                            const [key1, value1] = entry;
                            if (value1.type) {
                                value1.type = false;
                            }
                        });

                    });
                    detay[row][column].type = true
                    this.ekleme = true;
                }

            },
            handleSelect(item, ops, row, scope) {
                this.ekleme = true;
                this[ops] = item.cevap
                this.cevap = item.cevap
                this.cevapKodu = item.cevapKodu
                if (ops === 'aracMarka') {
                    scope["Araç Markası"].value = item.cevap;
                    scope["Araç Markası"].cevapKodu = item.cevapKodu;
                    this.cevapMarkaId = scope["Araç Markası"].id
                    this.cevapMarka = item.cevap
                    this.cevapKoduMarka = item.cevapKodu
                    this.scope = scope
                    this.editableMarka = []
                    this["editableModel"] = []
                    this["editableModel"][row] = true;
                    this.$set(this["editableModel"], row, true)
                }

            },
            querySearchOpsiyon(query, cb) {
                let self = this;
                var alan = '';
                switch (query) {
                    case this.aracMarka :
                        alan = 'arac_marka';
                        break;
                    case this.aracModel :
                        alan = 'arac_model';
                        break;
                    case this.ccm :
                        alan = 'ccm';
                        break;
                    case this.kW  :
                        alan = 'kw';
                        break;
                    case this.ps  :
                        alan = 'ps';
                        break;
                    case this.motorKodu :
                        alan = 'motor';
                        break;
                }
                var dizi = [];
                if (alan === 'arac_model') {
                    urunService.markayaGoreModelArama(query, this.scope["Araç Markası"].cevapKodu).then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                var item = {
                                    cevap: e.cevap,
                                    cevapKodu: e.cevapKodu,
                                };
                                dizi.push(item);
                                self.cbModel = dizi;
                            });
                            cb(dizi);
                        } else notification.Status(response.status, this)
                    })
                } else {
                    urunService.opsiyonGenelArama(query, alan).then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                var item = {
                                    cevap: e.cevap,
                                    cevapKodu: e.cevapKodu,
                                };
                                dizi.push(item);
                                if (alan === 'ccm') {
                                    self.cbCCM = dizi;
                                } else if (alan === 'kw') {
                                    self.cbkW = dizi;
                                } else if (alan === 'arac_marka') {
                                    self.cbMarka = dizi;
                                } else if (alan === 'arac_model') {
                                    self.cbModel = dizi;
                                }
                            });
                            cb(dizi);

                        } else notification.Status(response.status, this)
                    })
                }

            },
            clearable(scope, row, editable, detay, column) {
                this[editable] = [];
                this[editable][row] = false;
                this.$set(this[editable], row, false)
                if (detay[row][column]) {
                    detay[row][column].type = false
                }
            },
            kaydet(opsiyonAdi, scope, editable, cb) {
                if (opsiyonAdi === 'Kullanıldığı Yıl') {
                    var tarih = this.kullanildigiYil[0] + " - " + this.kullanildigiYil[1];
                    this.getOpsiyonGuncelle(scope[opsiyonAdi].id, tarih, scope[opsiyonAdi].cevapKodu, opsiyonAdi, scope, editable)
                } else if (opsiyonAdi === 'Araç Markası' || opsiyonAdi === 'Araç Modeli' || opsiyonAdi === 'Motor Kodu' || opsiyonAdi === 'kW' || opsiyonAdi === 'CCM' || opsiyonAdi === 'PS') {
                    if (this.ekleme) {
                        this.getOpsiyonGuncelle(scope[opsiyonAdi].id, this.cevap, this.cevapKodu, opsiyonAdi, scope, editable)
                    } else {
                        notification.Status('warning', this, 'Hatalı değer girdiniz.!');
                    }
                } else {
                    if (this.ekleme) {
                        this.getOpsiyonGuncelle(scope[opsiyonAdi].id, this.input, this.cevapKodu, opsiyonAdi, scope, editable)
                    } else {
                        notification.Status('warning', this, 'Hatalı değer girdiniz.!');
                    }
                }
            },
            getOpsiyonGuncelle(udetayId, cevap, cevapKodu, opsiyonAdi, scope, editable) {
                if (opsiyonAdi === 'Araç Modeli') {
                    urunService.urunGuncelleme(this.cevapMarkaId, this.cevapMarka, this.cevapKoduMarka).then((response) => {
                        if (response.status === 200) {
                            scope['Araç Markası'].value = this.cevapMarka;
                            this["editableMarka"] = []
                            urunService.urunGuncelleme(udetayId, cevap, cevapKodu).then((response) => {
                                if (response.status === 200) {
                                    scope[opsiyonAdi].value = cevap;
                                    this[editable] = []
                                    notification.Status('success', this, 'Araç Marka-Model başarıyla güncellendi.');
                                }
                            })
                        }
                    })
                } else {
                    urunService.urunGuncelleme(udetayId, cevap, cevapKodu).then((response) => {
                        if (response.status === 200) {
                            scope[opsiyonAdi].value = cevap;
                            this[editable] = []
                            this.input = "";
                            Object.entries(this.detay).forEach(entry => {
                                const [key, value] = entry;
                                Object.entries(value).forEach(entry => {
                                    const [key1, value1] = entry;
                                    if (value1.type) {
                                        value1.type = false;
                                    }
                                });
                            });
                            notification.Status('success', this, 'Ürün başarıyla güncellendi.');
                        }
                    })
                }
                this.ekleme = false;
            },

            exportKatalog(val) {
                let self = this;
                var item = {
                    updetayKodu: val.updetayKodu,
                    katalog: val.Katalog
                }
                self.multipleSelection.push(item)
                // console.log(this.multipleSelection)

            },
            //dede
        }
    }
    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')


    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }
</script>

<style lang="scss" scoped>
    .dangerbtn {
        color: #ec205f;
        position: absolute;
        bottom: -6px;
        right: -24px;
    }

    .successbtn {
        color: #13ce66;
        position: absolute;
        top: -6px;
        right: -24px;
    }

    .el-button--mini {
        padding: 0px 15px !important;
        height: 25px !important;
    }

    .tabloFirstChild {
        position: fixed;
    }
</style>
